import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import {default_state} from '../reducers';
import {getComposedReducer} from '../helpers/composeReducer.js';
import {routeReducer as routing} from 'redux-simple-router';
import {combineReducers} from 'redux';

let window = global.window || {};

function finalCreateStoreFunction(skip_logging) {
    return compose(
        applyMiddleware(thunk),
        skip_logging ? f => f : applyMiddleware(createLogger({
            collapsed: true
        })),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )(createStore);
}

let state = global.__STATE__ || {};
state = state.tbs || {};
let initial_state = {
    routing: {},
    tbs : {
        ...default_state,
        ...state
    }
}

export default function configureStore(initialState={initial_state}, skip_logging=false) {
    const reducer = getComposedReducer('tbs');
    const rootReducer = combineReducers({
        tbs : reducer,
        routing
    });


    const store = finalCreateStoreFunction(skip_logging)(rootReducer, initialState)
    return store;
}


// WEBPACK FOOTER //
// ./src/store/configureStore.js